import React, { useEffect, useState } from "react";
import { translate, translateDate } from "../../../../../common/providers";
import { CompanyLogoService } from "../../../../../api";
import { useApi } from "../../../../../common/hooks";
import { formatFileSize } from "../utils/logo-utils";
import styles from "./LogoHistoryTable.module.css";
import {
	CustomChips,
	CustomTable,
	CustomTableBody,
	CustomTableCell,
	CustomTableHead,
	CustomTableRow,
} from "../../../../../common/components";

function LogoThumbnail({ url, filename }) {
	const [objectUrl, setObjectUrl] = useState(null);
	const { call: getLogoImage } = useApi(CompanyLogoService.getLogoImage);
	useEffect(() => {
		if (!url) {
			return undefined;
		}
		getLogoImage(url)
			.then((blob) => {
				setObjectUrl(URL.createObjectURL(blob));
			})
			.catch(console.error);
		return () => {
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [url]);
	if (!objectUrl) {
		return <span className={styles.thumbnailPlaceholder} />;
	}
	return <img alt={filename} className={styles.thumbnail} src={objectUrl} />;
}

export default function LogoHistoryTable({ history = [] }) {
	return (
		<div className={styles.tableWrapper}>
			<CustomTable dense>
				<CustomTableHead>
					<CustomTableRow>
						<CustomTableCell className={styles.th}>#</CustomTableCell>
						<CustomTableCell className={styles.th}>
							{translate("admin.company-logo.history.th.preview")}
						</CustomTableCell>
						<CustomTableCell className={styles.th}>
							{translate("admin.company-logo.history.th.filename")}
						</CustomTableCell>
						<CustomTableCell className={styles.th}>
							{translate("admin.company-logo.history.th.size")}
						</CustomTableCell>
						<CustomTableCell className={styles.th}>
							{translate("admin.company-logo.history.th.uploaded")}
						</CustomTableCell>
					</CustomTableRow>
				</CustomTableHead>
				<CustomTableBody>
					{history.map((entry, index) => (
						<CustomTableRow key={entry.id} className={entry.active ? styles.activeRow : ""}>
							<CustomTableCell className={styles.td}>{index + 1}</CustomTableCell>
							<CustomTableCell className={styles.td}>
								<LogoThumbnail filename={entry.filename} url={entry.url} />
							</CustomTableCell>
							<CustomTableCell className={styles.td}>
								<span className={styles.filename}>{entry.filename}</span>
							</CustomTableCell>
							<CustomTableCell className={styles.td}>{formatFileSize(entry.fileSize)}</CustomTableCell>
							<CustomTableCell className={styles.td}>
								<span className={styles.dateCell}>
									{translateDate(entry.uploadedAt)}
									{entry.active && (
										<CustomChips
											color="success"
											label={translate("admin.company-logo.history.badge.active")}
											size="sm"
										/>
									)}
								</span>
							</CustomTableCell>
						</CustomTableRow>
					))}
				</CustomTableBody>
			</CustomTable>
		</div>
	);
}
